import { GENI_BACKEND_BASE_URL } from "@/api/geniBackend";

function isAbsoluteHttpUrl(value: string): boolean {
  return /^https?:\/\//i.test(value);
}

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, "");
}

function pickUploadedFileNameFromPath(pathname: string): string | null {
  const match = pathname.match(/\/uploads\/([^/?#]+)/i);
  return match?.[1] ?? null;
}

export function normalizeStoredImageRef(value: string): string {
  const raw = value.trim();
  if (!raw) return raw;
  if (raw.startsWith("blob:") || raw.startsWith("data:")) return raw;

  if (isAbsoluteHttpUrl(raw)) {
    try {
      const parsed = new URL(raw);
      const fromUploads = pickUploadedFileNameFromPath(parsed.pathname);
      return fromUploads ?? raw;
    } catch {
      return raw;
    }
  }

  const fromRelativeUploads = pickUploadedFileNameFromPath(raw);
  return fromRelativeUploads ?? raw;
}

export function resolveImageUrl(value: string): string {
  const raw = value.trim();
  if (!raw) return raw;
  if (raw.startsWith("blob:") || raw.startsWith("data:")) return raw;

  if (isAbsoluteHttpUrl(raw)) {
    try {
      const parsed = new URL(raw);
      const fromUploads = pickUploadedFileNameFromPath(parsed.pathname);
      if (!fromUploads) {
        return raw;
      }
      return `${trimTrailingSlash(GENI_BACKEND_BASE_URL)}/uploads/${fromUploads}`;
    } catch {
      return raw;
    }
  }

  const normalized = normalizeStoredImageRef(raw);
  if (!normalized) return normalized;
  if (normalized.startsWith("/")) {
    return `${trimTrailingSlash(GENI_BACKEND_BASE_URL)}${normalized}`;
  }
  if (normalized.includes("/")) {
    return normalized;
  }
  return `${trimTrailingSlash(GENI_BACKEND_BASE_URL)}/uploads/${normalized}`;
}
